
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { KanbanState } from '../kanban.model';

@Component({
  name: 'AlwaysShowOwnBoardsSetting',
  components: {},
})
export default class AlwaysShowOwnBoardsSetting extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  get alwaysShowMyBoards(): boolean {
    return this.state.settings!.alwaysShowMyBoards;
  }

  set alwaysShowMyBoards(val: boolean) {
    this.state.settings!.alwaysShowMyBoards = val;
    this.onAlwaysShowMyBoardsChanged();
  }

  get uid(): string {
    return (this as any)._uid;
  }

  private async saveSettings(): Promise<void> {
    await this.state.settingsAPI.update('KanbanSettings', false, false, JSON.stringify(this.state.settings));
  }

  private async onAlwaysShowMyBoardsChanged(): Promise<void> {
    await this.saveSettings();

    //TODO this is an ugly hack to trigger a refresh of the ui due to the layout variable change that should be triggered automatically by vue but isn't
    let x = this.state.settings;
    this.state.settings = null;
    this.state.settings = x;
  }
}
